'use strict';

var baseLogin = require('base/login/login');

var formValidation = require('base/components/formValidation');
var createNotification = require('eminence/components/notification');

var location = window.location;

const SELECTORS = {
    registrationForm: '.js-registration-form',
    selectedSkinCOncerns: '.js-registration-form-skinconcerns-selected',
    resetPasswordForm: '.js-reset-password-form',
    requestPasswordTitle: '.request-password-title',
    requestPasswordBody: '.js-request-password-body',
    submitEmailButton: '.js-submit-email-button',
    sendEmailButton: '.js-send-email-btn',
    passwordResetSubtitle: '.js-password-reset-subtitle',
    notificationMessage: '.js-notification-message, .error-messaging'
}

function register () {

    $(SELECTORS.registrationForm).on('submit', function (e) {
        var form = $(this);
        e.preventDefault();

        var url = form.attr('action');
        var $skinConcerns = $('input.js-skinconcerns-checkbox:checked');
        var skinConcernsIDs = [];
        $skinConcerns.each(function () {
            skinConcernsIDs.push($(this).attr('id'));
        });
        $(SELECTORS.selectedSkinCOncerns).val(JSON.stringify(skinConcernsIDs));

        $(SELECTORS.registrationForm).trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (!data.success) {
                    const errorMessages = Object.values(data.fields || {}).join(', ');
                    $(SELECTORS.registrationForm).trigger('login:register:error', data);
                    createNotification($(SELECTORS.notificationMessage), errorMessages || 'There is a problem with the submitted form', 'danger');
                    formValidation(form, data);
                } else {
                    $(SELECTORS.registrationForm).trigger('login:register:success', data);
                    location.href = data.redirectUrl;
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createNotification($(SELECTORS.notificationMessage), err.responseJSON.message, 'danger');
                }
            }
        });
        return false;
    });
}

function resetPassword () {
    $(SELECTORS.resetPasswordForm).on('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        var url = form.attr('action');
        $(SELECTORS.resetPasswordForm).trigger('login:register', e);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: form.serialize(),
            success: function (data) {
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    form.closest('.c-card')
                        .removeClass('c-card')
                        .addClass('c-card-replaced');
                    $(SELECTORS.requestPasswordTitle).text(data.receivedMsgHeading);
                    $(SELECTORS.passwordResetSubtitle).remove(); 
                    $('.b-page-title').text('Check Your Email');
                    $(SELECTORS.requestPasswordBody).empty()
                        .append('<p>' + data.receivedMsgBody + '</p>');
                    if (!data.mobile) {
                        $(SELECTORS.submitEmailButton).text(data.buttonText)
                            .attr('data-dismiss', 'modal');
                    } else {
                        $(SELECTORS.sendEmailButton).empty()
                            .html('<a href="'
                                + data.returnUrl
                                + '" class="f-button f-button--primary">'
                                + data.buttonText + '</a>');
                    }
                }
            },
            error: function () {
                console.error('Login error');
            },
        });
        return false;
    });
}

$('.b-email-verification-resend-cta').on('click', function (e) {
    e.preventDefault();

    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    if (email) {
        let href = $(this).attr('href');
        const separator = href.includes('?') ? '&' : '?';
        const newURL = href + separator + 'email=' + encodeURIComponent(email);
        location.href = newURL;
    } else {
        // Optionally handle missing email param
        console.warn('Email parameter not found in URL.');
    }
});

$('#headerLogin').on('shown.bs.modal', function () {
    $('#login-form-email').trigger('focus');
});

baseLogin.register = register;
baseLogin.resetPassword = resetPassword;

module.exports = baseLogin;
